import React, { FunctionComponent } from "react";

const ArrowSvgComponent: FunctionComponent = () => (
    <svg width="220px" height="30px" viewBox="0 0 500 50" xmlns="http://www.w3.org/2000/svg">
        <line x1="0" y1="25" x2="440" y2="25" stroke="black" strokeWidth="7" />
        <polygon points="100,5 150,25 100,45" strokeWidth="1" color="black" />
        <polygon points="300,5 350,25 300,45" strokeWidth="1" color="black" />
    </svg>
);

export default ArrowSvgComponent;
